import { useTheme, useMediaQuery } from '@mui/material';

type Breakpoint = 'small' | 'medium' | 'large';

export default function useThemeBreakpoint(): Breakpoint {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), { noSsr: true });
    const isLaptop = useMediaQuery(theme.breakpoints.between('md', 'lg'), { noSsr: true });

    if (isDesktop) {
        return 'large';
    }
    if (isLaptop) {
        return 'medium';
    }
    return 'small';
}
